<template>
    <div>
        <div class="alert alert-success" v-if="sent">
            {{ __('Your favorite exhibitor list has been sent!') }}
        </div>
        <div class="input-group">
            <input type="text" class="form-control" :placeholder="__('Email address')" v-model="email" @keyup.enter="send">
            <button class="btn btn-outline-secondary" :class="{ disabled : sending }" type="button" @click.prevent="send"><i class="fa fa-spin fa-circle-notch" v-if="sending"></i><i class="fa fa-check" v-if="recentlySent"></i> {{ __('Send') }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['locale'],
        data() {
            return {
                email : null,
                sending : false,
                recentlySent : false,
                sent : false,
            }
        },
        methods: {
            send() {
                if (this.sending) {
                    return;
                }

                this.sending = true;

                axios.post('/'+ this.locale +'/favorite-exhibitors/send', { email : this.email })
                     .then(response => {
                         this.sending = false;
                         this.sent = true;
                         this.recentlySent = true;

                         setTimeout(() => {
                             this.recentlySent = false;
                         }, 3000);
                     }).catch(response => {
                        alert(this.__('Something went wrong. Please try again.'))
                        this.sending = false;
                     });
            }
        },
        mounted() {
            //
        },
    }
</script>
